export default "__VITE_ASSET__48b78c57__"